import React from 'react';
import SummarizeList from '../../elements/Body/SummarizeList/SummarizeList';
import './SummarizePage.css';
class SummarizePage extends React.Component {
  render() {
    return (
      <>
        <SummarizeList />
      </>
    );
  }
}
export default SummarizePage;
